import { useState } from "react";
import PropTypes from "prop-types";
import { Loader } from "components/Loader";
import { BILLING_INTERVAL } from "utils/constants";
import {
  ConfirmDialogContainer,
  Title,
  Body,
  BillingBox,
  Actions,
  PrimaryButton,
  SecondaryButton,
} from "../shared/ConfirmDialog.styles";

export const ReactivateModal = ({
  show,
  onHide,
  onConfirm,
  currentPlan,
  renewalDate,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirm = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await onConfirm();
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (isSubmitting) return;
    onHide();
  };

  const intervalLabel =
    currentPlan?.interval === BILLING_INTERVAL.YEARLY ? "year" : "month";

  return (
    <ConfirmDialogContainer show={show} onHide={handleClose} backdrop="static">
      <Title>Reactivate subscription</Title>

      <Body>
        You&apos;ll keep access to {currentPlan?.name} and your next charge will
        be processed on {renewalDate}.
      </Body>

      <BillingBox>
        <div className="billing-left">
          <span className="billing-plan">{currentPlan?.name}</span>
          <span className="billing-date">Next charge {renewalDate}</span>
        </div>
        <span className="billing-price">
          ${currentPlan?.price} USD / {intervalLabel}
        </span>
      </BillingBox>

      <Actions>
        <SecondaryButton
          type="button"
          onClick={handleClose}
          disabled={isSubmitting}
        >
          Go back
        </SecondaryButton>
        <PrimaryButton
          type="button"
          onClick={handleConfirm}
          disabled={isSubmitting}
        >
          {isSubmitting && <Loader className="btn-loader" variant="light" />}
          Reactivate subscription
        </PrimaryButton>
      </Actions>
    </ConfirmDialogContainer>
  );
};

ReactivateModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  currentPlan: PropTypes.object,
  renewalDate: PropTypes.string,
};
